import img17a from '../../../assets/gallery/17b/17b-01-HOME_ST-2017-200x300cm-oleo-sobre-madera.jpg';
import img17b from '../../../assets/gallery/17b/17b-02_ST-2017-200x300cm-oleo-sobre-madera.jpg';
import img17c from '../../../assets/gallery/17b/17b-03_Substance-2017-200x300cm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img17a,
    description: "2017",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img17b,
    description: "2017",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img17c,
    description: "2017",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/17b/data17b.js